import React from 'react';
import { AccordionProvider } from './AccordionProvider';
import AccordionContent from './AccordionContent';
import AccordionTrigger from './AccordionTrigger';
/** @public */
const Accordion = ({
  open = false,
  shouldAnimate = true,
  shouldMapOpenPropToContent = false,
  children
}) => React.createElement(AccordionProvider, {
  open: open,
  shouldAnimate: shouldAnimate,
  shouldMapOpenPropToContent: shouldMapOpenPropToContent
}, children);
Accordion.Trigger = AccordionTrigger;
Accordion.Content = AccordionContent;
export default Accordion;